import React from 'react';

import {
  DeliveryIcon,
  DeliveryProgressContainer,
  IconContainer,
  ProgressContainer,
} from 'components/order-status/components/delivery-progress/styled';
import { ProgressBar } from 'components/progress-bar';
import { STATUS_PERCENTS } from 'pages/order-confirmation/delivery/delivery-progress';
import { DeliveryStatus } from 'state/order/types';

const ICON_OFFSET = 2;
export const DeliveryProgress = ({ deliveryStatus }: { deliveryStatus: DeliveryStatus }) => {
  return (
    <DeliveryProgressContainer>
      <ProgressContainer>
        <ProgressBar percentage={STATUS_PERCENTS[deliveryStatus]} />
      </ProgressContainer>
      <IconContainer left={STATUS_PERCENTS[deliveryStatus] - ICON_OFFSET + '%'}>
        <DeliveryIcon />
      </IconContainer>
    </DeliveryProgressContainer>
  );
};
